import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { IoChevronForwardSharp, IoHomeOutline } from "react-icons/io5";

import useBreadcrumbs from "use-react-router-breadcrumbs";
import accountService from "./../../../services/accountService";

const CreditableBreadcrumbs = ({ id, account, setAccount }) => {
  const staticBreadcrumb = ({ content }) => <>{content}</>;
  const accountBreadcrumb = () => <span>{account && account.short_name}</span>;

  const routes = [
    {
      path: "/",
      breadcrumb: staticBreadcrumb,
      props: {
        content: (
          <div className="flex items-center">
            <IoHomeOutline className="mr-3" /> Home
          </div>
        ),
      },
    },
    { path: "/accounts/:id", breadcrumb: accountBreadcrumb },
    {
      path: "/accounts/:id/creditables/",
      breadcrumb: staticBreadcrumb,
      props: { content: "2307" },
    },
  ];

  const breadcrumbs = useBreadcrumbs(routes);

  useEffect(() => {
    let mounted = true;

    const fetchAccount = async () => {
      const result = await accountService.getAccountInfoAsync(id);
      if (!result) window.location = "/404";
      if (mounted) setAccount(result);
    };

    fetchAccount(id);

    return () => {
      mounted = false;
    };
  }, [id, setAccount]);

  return (
    <nav className="flex px-3">
      <ol className="inline-flex items-center space-x-1 md:space-x-3 breadcrumbs">
        {breadcrumbs.map(({ match, breadcrumb }) => (
          <li key={match.pathname} className="inline-flex items-center">
            <NavLink
              to={match.pathname}
              className="inline-flex items-center text-sm text-gray-500 hover:text-blue-500"
            >
              {breadcrumb}
            </NavLink>
            <IoChevronForwardSharp className="ml-3 text-gray-400" />
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default CreditableBreadcrumbs;
